import React from 'react';
import PropTypes from 'prop-types';

import './FieldSelect.sass';

import cx from 'classnames';

export default function FieldSelect({input, meta: {touched, error} = {}, label, className, children, small, ...rest}) {
  const displayError = (touched && error);

  return (
    <div className={cx('field-select', small && 'field-select--small', className)}>
      {label && <label className="field-select__title">{label}</label>}

      <div className="field-select__input-wrap">
        <select {...rest} {...input} className="field-select__select">
          {children}
        </select>
      </div>

      {displayError && (<div className="field-select__error-message">{error}</div>)}
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/fields/fieldSelect/FieldSelect.js